export const useGetProvidersFromCampaigns = (campaigns = []) => {
  const providers = new Set()

  campaigns.forEach(({ provider }) => {
    providers.add(provider)
  })

  return Array.from(providers)
}
